<h1 style="text-align: center;" mat-dialog-title >New <span style="font-size: 23px;" *ngIf="data.isBasket">Basket</span> <span style="font-size: 23px;" *ngIf="!data.isBasket">Item</span> Entry</h1>
<div mat-dialog-actions style="margin: auto" class="actions">
        <div style="width: 100%; margin: 5px;">
        </div>


        <mat-form-field *ngIf="!data.isBasket" style="margin: auto" class="example-full-width">
          <mat-label>Name</mat-label>
          <input [(ngModel)]="data.Item" matInput value="">
        </mat-form-field>

        <mat-form-field   style="margin: auto" class="example-full-width">
          <mat-label>Price</mat-label>
          <input type="tel" [(ngModel)]="data.Retail" matInput value="">
        </mat-form-field>





        <mat-form-field  style="margin: auto"  class="example-full-width">
          <mat-label>Quantity</mat-label>
          <input type="tel" [(ngModel)]="data.Quantity" matInput value="">
        </mat-form-field>

        <mat-form-field  style="margin: auto"  class="example-full-width">
          <mat-label>Bar Code</mat-label>
          <input [(ngModel)]="data.RawNumber" matInput value="">
        </mat-form-field>

        <!-- <mat-form-field *ngIf="!data.isBasket" style="margin: auto"  appearance="">
          <mat-label>Category</mat-label>
          <mat-select [(ngModel)]="data.Category">
            <mat-option *ngFor="let category of data.Categories " value="{{category}}">{{category}}</mat-option>
          </mat-select>
        </mat-form-field> -->


        <mat-form-field style="margin: auto; font-size: 12px;;" *ngIf="!data.isBasket" class="example-full-width">
          <input type="text"
              placeholder="Category"
              aria-label="Number"
              matInput
              [formControl]="myControlCategories"
              [matAutocomplete]="auto"
              [(ngModel)]="data.Category">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"  >
            <mat-option style="font-size: 12px;" *ngFor="let category of filteredOptionsCategories | async" [value]="category" >
            {{category}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>



    <div style="width: 100%; margin: 5px;">
        
          <div id="camera" style="float: right; width: 100%; margin-bottom: 5px; margin-left: 10px;" class="fileUpload col-2 p-1 text-purple camera-btn">
                
            <i class="fa fa-camera" size="xl" style="font-size:30px; float: right;" ></i>
            <input  type="file" accept="image/*" capture="capture" multiple name="image" class="upload"  (change)="fileUploaded($event)" /> 
        </div>
        <button style="float: right; " mat-raised-button color="primary" [mat-dialog-close]="data" (click)="data.Cancelled  = false"  cdkFocusInitial>Done</button>
        <button style="float: right; margin-right: 10px;" mat-raised-button color="warn" (click)="data.Cancelled  = true" [mat-dialog-close]="data" cdkFocusInitial>Cancel</button>
    </div>
</div>